// Libs
import React, { useState, useContext } from "react";
import { useObserver } from "@shoothill/core";
import { StoresContext, Stores } from "Globals/Stores";

// View models
import EmploymentDetailsViewModel from "Globals/ViewModels/FormSections/EmploymentDetails/EmploymentDetailsViewModel";
import ArmedForcesProofViewModel from "Globals/ViewModels/FormSections/EmploymentDetails/ArmedForcesProofViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";

// Views
import { FileUploader } from "Globals/Views/FileUploader";

// Styles
import { Row } from "Globals/Styles/LayoutStyles";

// Types
import { UserFile } from "Globals/Models/UserFile";

interface IProps {
    employmentDetailsViewModel: EmploymentDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const ArmedForcesProofView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(() => new ArmedForcesProofViewModel());
    return useObserver(() => (
        <>
            <Row>
                <FileUploader
                    files={props.employmentDetailsViewModel.getArmedForcesProofUserFiles}
                    text={"Please provide proof with your application"}
                    onUpload={(userFile: UserFile) => viewModel.stash(userFile, props.employmentDetailsViewModel)}
                    onDelete={(userFile: UserFile) => {
                        let viewModel = props.employmentDetailsViewModel.armedForcesProofViewModels.find((vm) => vm.model.fileUrl == userFile.fileUrl);
                        if (viewModel) {
                            viewModel.delete(props.employmentDetailsViewModel);
                        }
                    }}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                />
            </Row>
        </>
    ));
};
